// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"; // ← Import QueryClient
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { UserProvider } from "./context/UserContext";
import ErrorBoundary from "./components/ErrorBoundary";
// Web vitals are optional; disable to avoid runtime errors if the web-vitals
// bundle shape changes.
// import reportWebVitals, { sendToGoogleAnalytics } from "./reportWebVitals";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 1 minute
      staleTime: 60 * 1000,
      // Don't refetch just because user clicked the window
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserProvider>
          <App />
        </UserProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorBoundary>
);

// Report Web Vitals to Google Analytics
// reportWebVitals(sendToGoogleAnalytics);
